// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { isEmbedPath } from "./embed";

// The widget picks its language from the business it books for and must not
// remember it. Without this, the detector caches every changeLanguage in
// localStorage — and the dashboard previews the widget in a same-origin
// iframe, so opening the preview of a Romanian business would quietly switch
// an English-speaking owner's own dashboard to Romanian.
const isEmbed =
  typeof window !== "undefined" && isEmbedPath(window.location.pathname);

i18n
  .use(Backend) // Load translations from your server
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n down to react-i18next
  .init({
    fallbackLng: "en", // Fallback language if detected language is not available

    // We ship one bundle per language, not per region: `en/` and `ro/`. Without
    // this the detector asks for the browser's full tag — "en-US" — the SPA
    // answers that request with index.html, and i18next logs a JSON parse
    // failure on every page load before falling back. Ask for the base language
    // and the first request is the right one.
    load: "languageOnly",

    // Chatty by design in development, silent in the build the customer loads.
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false, // React already safes from xss
    },

    // On the widget's path: a first guess from the browser only (EmbedBooking
    // then switches to the business's language), and remember nothing.
    //
    // Elsewhere: an explicit ?lng=, then the language this browser chose
    // before (the switcher saves it), then the page's own <html lang> —
    // Romanian, or the business's language on a booking page the API wrote.
    // Never the browser's: Googlebot renders as en-US, so reading `navigator`
    // had Google index an English copy of a Romanian site, and plenty of
    // Romanians run an English browser too. English is one click away.
    detection: isEmbed
      ? { order: ["navigator", "htmlTag"], caches: [] }
      : { order: ["querystring", "localStorage", "htmlTag"], caches: ["localStorage"] },
    // Load translations from your backend
    backend: {
      loadPath: "/static/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
